import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { useNuevoDetalleHorario } from './hooks/useNuevoDetalleHorario';

const NuevoDetalleHorario = ({ horarioId, ocultaDialogNuevo }) => {

    const { horaIni, horaFin, setHoraIni, setHoraFin, esNocturno, setEsNocturno, habilita, registraDetalle } = useNuevoDetalleHorario(horarioId, ocultaDialogNuevo)

    return (
        <div className="card">
            <h5>Ingrese nuevo horario</h5>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-6">
                    <label htmlFor="">Hora Inicio:</label>
                    <Calendar value={horaIni} onChange={(e) => setHoraIni(e.value)} timeOnly />
                </div>
                <div className="field col-12 md:col-6">
                    <label htmlFor="">Hora Fin:</label>
                    <Calendar value={horaFin} onChange={(e) => setHoraFin(e.value)} timeOnly />
                </div>
                <div className="field col-12 md:col-6">
                    <Checkbox checked={esNocturno} onChange={(evt) => setEsNocturno(evt.checked)} />
                    <label>Es Horario Nocturno</label>
                </div>
                <div className="field col-12 md:col-6">
                    <div className="flex justify-center gap-5">
                        <Button label="Cancelar" style={{ width: '100px' }} onClick={ocultaDialogNuevo} disabled={habilita} />
                        <Button label="Registar" style={{ width: '100px' }} onClick={registraDetalle} disabled={habilita} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NuevoDetalleHorario;
